var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/victory-group/~/lodash/_Symbol.js
// module id = ./node_modules/victory-group/node_modules/lodash/_Symbol.js
// module chunks = 1